import { SVGProps, memo } from 'react';

const DeleteIcon2 = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg width="15" height="18" viewBox="0 0 15 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1.5 16C1.5 17.1 2.4 18 3.5 18H11.5C12.6 18 13.5 17.1 13.5 16V4H1.5V16ZM14.5 1H11L10 0H5L4 1H0.5V3H14.5V1Z" fill="black" fill-opacity="0.56"/>
    </svg>
  );
};

export default memo(DeleteIcon2);
